document.addEventListener("DOMContentLoaded", () => {

    let projectCategoryButtons = document.querySelectorAll('.projects-slider__toggle button');
    let projectItems = document.querySelectorAll('.projects-slider__list .wrap-item');
    if (projectCategoryButtons) {
        projectCategoryButtons.forEach((button) => {
            button.addEventListener('click', () => {
                let categoryId = button.getAttribute('data-category-id');

                projectCategoryButtons.forEach((item)=>{
                    item.classList.remove('active');
                });
                button.classList.add('active');

                projectItems.forEach((item) => {
                    let projectCategoryId = item.getAttribute('data-project-category-id');
                    if (projectCategoryId === categoryId || !categoryId) {
                        item.classList.remove('hidden');
                    } else {
                        item.classList.add('hidden');
                    }
                })
            })
        })
    }
});
